// Is the window PHONE-wide right now, asked outside a component (busy-my-web#706)?
//
// `useIsMobile` (composables/useIsMobile.js) is the reactive answer for components; a store action
// has no setup to hold a ref, so it asks the same media query once, at the moment it acts. Same
// breakpoint (Tailwind's `md`, 768px), so the two never disagree. Without `matchMedia` (jsdom, an old
// browser) it answers false: the desktop behaviour every existing spec pins is the default.

import { MOBILE_QUERY } from '@/composables/useIsMobile'

export function isPhoneViewport(win = typeof window !== 'undefined' ? window : undefined) {
  if (typeof win?.matchMedia !== 'function') return false
  return !!win.matchMedia(MOBILE_QUERY)?.matches
}

